<div class="blog-links" *ngIf="form">
  <form [formGroup]="form">
    <app-multiselect-dropdown
      [multiselect]="true"
      (lastElementIsVisible)="loadMoreIfLastIndex()"
      [optionLoading]="
        isLoading && ((blogFilter | async)?.pageNumber ?? 0) === 1
      "
      [paginationLoading]="isLoading"
      [pagination]="totalBlog > blogList.length"
      [config]="dropDownConfig"
      [options]="blogOptions"
      [control]="form.get('relativeBlogIds')"
      (searchEvent)="handleSearch($event)"
      [error]="''"
    >
    </app-multiselect-dropdown>
  </form>
  <ng-container
    *ngFor="let link of form.get('relativeBlogIds')?.value || []; let i = index"
  >
    <div class="blog-links__item flex align-center justify-between">
      <p>{{ link.label }}</p>

      <button
        (click)="removeLink(link?.value)"
        class="flex align-center justify-center"
      >
        <img src="assets/images/delete.svg" alt="Delete" />
      </button>
    </div>
  </ng-container>
</div>
